/**
 * Engine API
 * Engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This model matches the backend ScenarioLogDto
 */

export interface ScenarioLogDto {
    id?: number;
    scenarioId?: string;
    version?: number;
    personalId?: number;
    level?: ScenarioLogDto.LevelEnum;
    eventCode?: string;
    stepPath?: string;
    stepType?: string;
    message?: string;
    contextJson?: string;
    createdAt?: string;
}

export namespace ScenarioLogDto {
    export type LevelEnum = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';
    export const LevelEnum = {
        DEBUG: 'DEBUG' as LevelEnum,
        INFO: 'INFO' as LevelEnum,
        WARN: 'WARN' as LevelEnum,
        ERROR: 'ERROR' as LevelEnum
    };
}
